import { Auth } from "aws-amplify";

export async function getAlias() {
    const userInfo = await Auth.currentUserPoolUser()
    return userInfo.username.split('_')[1]
}